import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';

interface VendorSelectProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  disabled?: boolean;
}

export const VendorSelect: React.FC<VendorSelectProps> = ({ 
  value, 
  onChange, 
  error,
  disabled = false 
}) => {
  const { t } = useTranslation();
  const { vendors } = useSelector((state: RootState) => state.vendors);

  return (
    <div>
      <label htmlFor="vendor_id" className="block text-sm font-medium text-gray-700">
        {t('sales.vendor')} *
      </label>
      <select
        id="vendor_id"
        name="vendor_id"
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
      >
        <option value="">{t('common.select')} {t('sales.vendor')}</option>
        {vendors.map((vendor) => (
          <option key={vendor.id} value={vendor.id}>
            {vendor.name}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};